module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "background": "#f8f8f8",
      "padding-bottom": "5rem"
    }
  }, [_c('div', {
    staticClass: "check-header"
  }, [_c('div', {
    staticClass: "business-shop-info"
  }, [_c('div', {
    staticClass: "business-shop-box",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start"
    }
  }, [(_vm.row.status_icon) ? _c('img', {
    staticClass: "load-img",
    staticStyle: {
      "width": "1.2rem",
      "height": "1.2rem",
      "margin": "10px"
    },
    attrs: {
      "src": 'https://static.dierqudao.com/images/icon-order-' + _vm.row.status_icon + '.png',
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shop-name"
  }, [_c('div', {
    staticStyle: {
      "font-size": "19px"
    }
  }, [_vm._v(_vm._s(_vm.row.status_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "delivery-times"
  }, [_c('div', {
    staticClass: "timers-start"
  }, [_c('van-icon', {
    attrs: {
      "name": "clock-o"
    }
  }), _vm._v(" 时间地点\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "timers-end"
  }, [_vm._v(_vm._s(_vm.row.apply.province) + _vm._s(_vm.row.apply.city) + "(" + _vm._s(_vm.row.apply.datetitle) + ")")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("考级信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.row.apply.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "地址",
      "value": _vm.row.apply.address
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("运动员信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readony": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.name),
      callback: function($$v) {
        _vm.$set(_vm.row, "name", $$v)
      },
      expression: "row.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readony": "",
      "label": "身份证",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.num),
      callback: function($$v) {
        _vm.$set(_vm.row, "num", $$v)
      },
      expression: "row.num"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readony": "",
      "label": "报考星级",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.grade),
      callback: function($$v) {
        _vm.$set(_vm.row, "grade", $$v)
      },
      expression: "row.grade"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("费用信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readony": "",
      "label": "考级费",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.a_price),
      callback: function($$v) {
        _vm.$set(_vm.row, "a_price", $$v)
      },
      expression: "row.a_price"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readony": "",
      "label": "考级服费",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.c_price),
      callback: function($$v) {
        _vm.$set(_vm.row, "c_price", $$v)
      },
      expression: "row.c_price"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readony": "",
      "label": "考级鞋费",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.s_price),
      callback: function($$v) {
        _vm.$set(_vm.row, "s_price", $$v)
      },
      expression: "row.s_price"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readony": "",
      "label": "总计",
      "input-align": "right"
    },
    model: {
      value: (_vm.row.price),
      callback: function($$v) {
        _vm.$set(_vm.row, "price", $$v)
      },
      expression: "row.price"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "qcxj_member_apply",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04f37e7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyJoinDetail.vue
// module id = 2181
// module chunks = 0